module.exports = "/_next/static/images/e98f952699ecc7ddb97d3522d741953c-gray-mark.svg";